
    <div *ngIf="displayError && errorMsg" >
      <!--<span class="far fa-times-circle form-control-feedback fix-error-icon"></span>-->
      <span class="sr-only">(error)</span>

      <div class="error-msg" id="elemID">
      <i class="fas fa-exclamation-triangle"></i> {{ errorMsg }}
      </div>
    </div>
